import * as yup from "yup";

import type { YupSchemaValue } from "@src/shared/utils/yup";

export const StaffProfileFormValidationSchema = yup.object({
  firstName: yup.string().trim().required("First name is required"),
  lastName: yup.string().trim().required("Last name is required"),
});

export type StaffProfileFormValues = YupSchemaValue<
  typeof StaffProfileFormValidationSchema
>;

export const StaffProfileUpdatePayloadSchema = yup
  .object({
    firstName: yup.string().trim().required(),
    lastName: yup.string().trim().required(),
  })
  .transform((_value, originalValue: StaffProfileFormValues) => ({
    firstName: originalValue.firstName.trim(),
    lastName: originalValue.lastName.trim(),
  }));
